module.exports = __webpack_public_path__ + "static/media/tn.440d3505.svg";